import React from 'react';
import { AlertCircle } from 'lucide-react';

export default class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false, error: null, errorInfo: null };
  }

  static getDerivedStateFromError(error) {
    return { hasError: true };
  }

  componentDidCatch(error, errorInfo) {
    console.error('Error caught by boundary:', error, errorInfo);
    this.setState({
      error,
      errorInfo,
    });
  }

  render() {
    if (this.state.hasError) {
      return (
        <div className="min-h-screen bg-gradient-to-b from-slate-900 via-slate-800 to-blue-900 flex items-center justify-center px-4">
          <div className="text-center max-w-lg bg-slate-800 p-8 rounded-lg border border-red-500">
            <div className="mb-6">
              <AlertCircle className="w-16 h-16 text-red-500 mx-auto mb-4" />
              <h1 className="text-3xl font-extrabold text-white mb-2">Terjadi Kesalahan</h1>
              <p className="text-red-400">Aplikasi mengalami kesalahan yang tidak terduga</p>
            </div>

            <div className="bg-slate-900 rounded p-4 mb-6 text-left max-h-48 overflow-y-auto">
              <p className="text-gray-300 text-xs font-mono whitespace-pre-wrap">
                {this.state.error?.toString()}
              </p>
            </div>

            <div className="flex gap-4 flex-col justify-center">
              <button
                onClick={() => window.location.href = '/admin/dashboard'}
                className="px-6 py-3 bg-blue-600 text-white font-semibold rounded-lg hover:bg-blue-700 transition-colors"
              >
                Kembali ke Dashboard
              </button>
              <button
                onClick={() => window.location.reload()}
                className="px-6 py-3 bg-gray-700 text-white font-semibold rounded-lg hover:bg-gray-600 transition-colors"
              >
                Muat Ulang Halaman
              </button>
            </div>

            <p className="text-gray-400 text-xs mt-6">
              Jika masalah terus berlanjut, silahkan hubungi tim support.
            </p>
          </div>
        </div>
      );
    }

    return this.props.children;
  }
}
